import {
  CHANGE_START_DATE,
  CHANGE_END_DATE,
  CHANGE_CATEGORY,
  UPDATE_GEO,
  UPDATE_BOUNDS,
  SET_DEVICE_LOCATION,
  SYNC_DEVICE_LOCATION,
  SET_DOWNLOAD_PERC,
} from "../actions/forms";

const init = {
  startDate: "2019-10-1",
  endDate: "2021-10-31",
  selectedCategory: "Todos",
  zoom: 12,
  lat: 32.51,
  lng: -117.03,
  percentage: 0,
  locationLat: 32.51,
  locationLng: -117.03,
  latRange: [32.39672517121821, 32.63180661469565],
  lngRange: [-117.09437301635742, -116.96562698364258],
};

export default function formElements(
  state = init,
  action = { type: "other", payload: {} }
) {
  if (action.payload) {
    var {
      startDate,
      endDate,
      selectedCategory,
      lat,
      lng,
      zoom,
      latRange,
      lngRange,
      locationLat,
      locationLng,
      percentage,
    } = action.payload;
  }
  switch (action.type) {
    case CHANGE_START_DATE:
      return { ...state, startDate };
    case CHANGE_END_DATE:
      return { ...state, endDate };
    case CHANGE_CATEGORY:
      return { ...state, selectedCategory };
    case UPDATE_GEO:
      return { ...state, lat, lng, zoom };
    case UPDATE_BOUNDS:
      return { ...state, latRange, lngRange };
    case SET_DEVICE_LOCATION:
      return { ...state, locationLat, locationLng };
    case SYNC_DEVICE_LOCATION:
      return {
        ...state,
        lat: state.locationLat,
        lng: state.locationLng,
        zoom: 16,
      };
    case SET_DOWNLOAD_PERC:
      return { ...state, percentage };
    default:
      return state;
  }
}
